import * as Api from '@ViewModels';
import moment from 'moment';

/**
 * Integration providers whose presence puts the Service Jobs board into view-only mode,
 * since job data flows in from the home-services integration rather than Levitate.
 */
export const SERVICE_JOB_PROVIDERS: Api.IntegrationProvider[] = [
	Api.IntegrationProvider.HousecallPro,
	Api.IntegrationProvider.ServiceTitan,
];

/** Formats an ISO date string for display, falling back to a dash when empty. */
export const formatServiceJobDate = (dateString?: string) => {
	if (!dateString) {
		return '-';
	}
	return moment(dateString).format('MM/DD/YYYY');
};

/** Formats a numeric amount as USD currency, falling back to a dash when empty. */
export const formatServiceJobCurrency = (value?: number) => {
	if (value === undefined || value === null) {
		return '-';
	}
	return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
};
